<div class="d-flex tags-list">
  <span *ngFor="let tag of tags; trackBy: trackByFn" class="label label-light"> {{ tag }} </span>
</div>
